/**
 * Reine Helfer für useIssuesFilters (ausgelagert für Hook-Size-Limit).
 */
import type { ProductWithIssues } from '@/lib/api/channel-readiness'

export type IssuesSort = 'count_desc' | 'count_asc' | 'name_asc'

export function tally(
  products: ProductWithIssues[],
  key: 'issue_type' | 'severity',
): Record<string, number> {
  const counts: Record<string, number> = {}
  for (const p of products)
    for (const i of p.issues) {
      const v = key === 'issue_type' ? i.issue_type : (i.severity ?? 'info')
      counts[v] = (counts[v] ?? 0) + 1
    }
  return counts
}

const COMPARATORS: Record<
  IssuesSort,
  (a: ProductWithIssues, b: ProductWithIssues) => number
> = {
  count_desc: (a, b) => b.issue_count - a.issue_count,
  count_asc: (a, b) => a.issue_count - b.issue_count,
  name_asc: (a, b) => (a.name ?? '').localeCompare(b.name ?? ''),
}

export function sortProducts(
  products: ProductWithIssues[],
  sort: IssuesSort,
): ProductWithIssues[] {
  return [...products].sort(COMPARATORS[sort])
}

export function toggleValue(
  set: Set<string>,
  fn: (s: Set<string>) => void,
): (v: string) => void {
  return (v: string) => {
    const next = new Set(set)
    if (next.has(v)) next.delete(v)
    else next.add(v)
    fn(next)
  }
}
